import React from "react";
import Image from "./Image";
import Login from "./Login";
import "./LoginPage.css";

const LoginPage = () => {
  return (
    <div className="container">
      <Image />
      <Login />
    </div>
  );
};

export default LoginPage;
